<script setup>
import PracticeRaceVehicle from '@/Pages/Teacher/Gamification/Groups/PracticeRace/partials/PracticeRaceVehicle.vue';
import { computed } from 'vue';

const props = defineProps({
    factions: {
        required: true,
        type: Array,
    },
    practiceRace: {
        required: false,
        type: Object,
    },
});

const sortedFactions = computed(() => {
    return [...props.factions].sort((a, b) => {
        return b.qty - a.qty;
    });
});

const colors = {
    red: { text: 'text-red-500', background: 'bg-red-500' },
    green: { text: 'text-green-500', background: 'bg-green-500' },
    indigo: { text: 'text-indigo-500', background: 'bg-indigo-500' },
    blue: { text: 'text-blue-500', background: 'bg-blue-500' },
    purple: { text: 'text-purple-500', background: 'bg-purple-500' },
    pink: { text: 'text-pink-500', background: 'bg-pink-500' },
};
</script>
<template>
    <div v-if="practiceRace">
        <div>
            {{ practiceRace.name }}
        </div>
        <div class="italic">
            {{ practiceRace.description }}
        </div>
    </div>
    <div
        class="w-full relative"
        style="background-image: url('/img/gamification/background_tiles/sea_water.jpg'); min-height: 300px"
    >
        <div
            class="absolute top-0 h-full w-8 opacity-50 bg-repeat-y"
            style="background-image: url('/img/gamification/background_tiles/checkerboard.svg'); right: 1rem"
        />
        <div class="mr-32">
            <div class="h-28 relative" v-for="(faction, index) in factions" :key="faction.id">
                <div class="h-12 absolute">
                    <img :src="faction.image_path" alt="faction" class="h-12 object-contain" />
                </div>
                <div
                    class="h-28 absolute boat"
                    :style="`left: ${faction.percent}%; animation-delay: ${Math.round(1000 / index)}ms; transform-origin: 0% 100%;`"
                >
                    <PracticeRaceVehicle :class="colors[faction.color].text" class="w-28 h-28" />
                    <img
                        v-if="faction.student"
                        :title="faction.student.full_name"
                        :src="faction.student.avatar_or_default"
                        class="relative z-30 inline-block h-8 w-8 rounded-full ring-2 ring-white"
                        alt=""
                        style="top: -80%; right: -40%"
                    />
                </div>
            </div>
        </div>
    </div>
    <div>
        <div v-for="faction in sortedFactions" :key="faction.id" class="mt-3">
            <label for="">
                <div class="flex items-center gap-2">
                    <div :class="colors[faction.color].background" class="w-8 h-8"></div>
                    <div>
                        {{ faction.name }}
                    </div>
                    <div class="text-gray-500">({{ faction.percent }}%)</div>
                </div>
            </label>
        </div>
    </div>
</template>

<style>
.boat {
    animation: boat 2s ease-in-out infinite;
}

@keyframes boat {
    0% {
        transform: rotate(0);
    }
    5% {
        transform: rotate(-10deg);
    }

    20% {
        transform: rotate(0);
    }

    30% {
        transform: rotate(-3deg);
    }

    40% {
        transform: rotate(0deg);
    }

    50% {
        transform: rotate(-3deg);
    }

    60% {
        transform: rotate(0deg);
    }

    70% {
        transform: rotate(-3deg);
    }

    80% {
        transform: rotate(0deg);
    }

    90% {
        transform: rotate(-3deg);
    }

    100% {
        transform: rotate(0);
    }
}
</style>
